import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getStockData, getHkStockData } from '../../../../../services/api';
import { rel } from '../../../../../utils/rel';
class StockBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        current: 0,
        prices: [],
    };

    /**
     * 请求数据
     */
    async componentDidMount() {
        try {
            const { content } = this.props;
            const codeList = content.map(item => item.code);
            const result = await getStockData(codeList);
            const hkData = await getHkStockData();

            const price = codeList.map((item, index) => {
                let style = '';

                if (index === 3) {
                    if (hkData.chg_pct > 0) {
                        style = 'red';
                    } else if (hkData.chg_pct < 0) {
                        style = 'green';
                    } else {
                        style = 'black';
                    }
                } else if (result[item][2] > 0) {
                    style = 'red';
                } else if (result[item][2] < 0) {
                    style = 'green';
                } else {
                    style = 'black';
                }

                return {
                    price: index === 3 ? hkData.last : result[item][0],
                    index: index === 3 ? hkData.chg : result[item][2],
                    percent: index === 3 ? hkData.chg_pct : result[item][3],
                    style,
                };
            });

            this.setState({ prices: price });
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * 渲染组件
     */
    render() {
        const { prices } = this.state;
        const { content } = this.props;

        return (
            <div className={styles.stock_box}>
                {content.map((item, index) => (
                    <div key={index} className={`${styles.stock_container} ${styles[`box${index}`]}`}>
                        <a
                            href={
                                item.url && item.url !== ''
                                    ? item.url
                                    : `//finance.ifeng.com/app/hq/${item.type}/${item.code}`
                            }
                            target="_blank"
                            rel={rel}>
                            <div className={styles.text}>{item.name}</div>
                            <div className={`${styles.price} ${prices.length > 0 ? styles[prices[index].style] : ''}`}>
                                {prices.length > 0 ? prices[index].price : ''}
                            </div>
                            <div
                                className={`${styles.change_box} ${
                                    prices.length > 0 ? styles[prices[index].style] : ''
                                }`}>
                                {prices.length > 0 ? prices[index].index : ''}
                                <span>|</span>
                                {prices.length > 0 ? `${prices[index].percent}%` : ''}
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        );
    }
}

export default errorBoundary(StockBox);
